// @flow
import * as React from 'react'
import { FormattedMessage } from 'mz-intl'
import shallowEqual from 'mz-utils/shallowEqual'
import RadioField from 'mz-ui-kit/form/RadioField'
import type { Input, Meta } from 'mz-ui-kit/core/BaseField'
import { wrapWithField } from '../../Field'
import DirectBillIcon from '../assets/direct-bill'
import { PAY_WITH_DIRECT_BILL } from '../constants'
import messages from '../messages.intl'
import {
  Container,
  BrandContainer,
  Label,
  LabelName,
  LabelValue,
} from './elements'

// Types
export type Props = {
  input: Input,
  meta: Meta,
}

// Constants
const DIRECT_BILL_VALUE = {
  type: PAY_WITH_DIRECT_BILL,
}

/**
 * Component for DirectBill option
 * @param  {Object} props.option   A payment option object
 * @return {React.Element}
 */
const DirectBillMethod = (props: Props) => {
  const active =
    !!props.input && shallowEqual(props.input.value, DIRECT_BILL_VALUE)

  const handleContainerClick = () => {
    const { onChange } = props.input
    if (active) {
      return
    }
    onChange && onChange(DIRECT_BILL_VALUE)
  }

  return (
    <Container $active={active} onClick={handleContainerClick}>
      <RadioField
        {...props}
        activeValue={DIRECT_BILL_VALUE}
        inactiveValue={null}
      />
      <BrandContainer>
        <DirectBillIcon />
      </BrandContainer>
      <Label>
        <LabelName>
          <FormattedMessage message={messages.DIRECT_BILL} />
        </LabelName>
        <LabelValue>
          <FormattedMessage message={messages.DIRECT_BILL_INFO} />
        </LabelValue>
      </Label>
    </Container>
  )
}

export default wrapWithField(DirectBillMethod)
